export default __webpack_public_path__ + "static/media/dr-charles-obstansa-rounded.ea297c3d.png";